import { ILaborCallout, LaborCallout } from "../../../entities-generated/common/labor-callout";
import { IStandardLabor } from "../../../entities-generated/common/standard-labor";
import { IStandardMaterial } from "../../../entities-generated/common/standard-material";

export interface IAssessmentLaborEditingModel extends ILaborCallout {
  standardLabor: IStandardLabor | null;
  standardMaterialOptions: IStandardMaterial[];
}

export class AssessmentLaborEditingModel extends LaborCallout implements IAssessmentLaborEditingModel {
    constructor(
      callout: ILaborCallout = new LaborCallout(),
      public standardLabor: IStandardLabor | null = null,
      public standardMaterialOptions: IStandardMaterial[] = []
    )
    {
      super();
      this.standardLaborId = callout.standardLaborId;
      this.id = callout.id;
      this.description = callout.description;
      this.customerSummary = callout.customerSummary;
      this.time = callout.time;
      this.materials = callout.materials;
    }
}
